import request from 'api/requestUtils'
import { RequestDemoData } from 'businessTraveller/components/demo-form/RequestDemoForm'

async function requestDemo(businessData: RequestDemoData) {
  return request.post(
    '/api/business-traveller/request-demo',
    businessData,
  )
}

export default requestDemo
